
// const STORAGE_KEY = 'grocery-list';

export const itemsStorageFunc = {
    fetch: function(key) {
        var items = JSON.parse(window.localStorage.getItem(key)) || [];
        items.forEach((item, index) => {
            item.id = index;
        });
        itemsStorageFunc.uid = items.length;
        return items;
    },
    save: function(key, items) {
        window.localStorage.setItem(key, JSON.stringify(items));
    }
};

export const itemsStorageFilters = {
    all: function(items) {
        return items;
    },
    active: function(items) {
        return items.filter(item => {
            return !item.completed;
        });
    },
    completed: function(items) {
        return items.filter(item => {
            return item.completed;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/utils/items-storage.js